import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";
import SubscripationPlanApiReducer from "./reducer/SubscripationPlanReducer";

const appReducer = combineReducers({
  subscripation : SubscripationPlanApiReducer
});
const rootReducer = (state, action) => {
  return appReducer(state, action);
};

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
